import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.progress": "Progress",
      "nav.costs": "Costs",
      "nav.manpower": "Manpower",
      "nav.more": "More",
      
      // Login Page
      "login.welcome": "Welcome Back",
      "login.subtitle": "Sign in to access your Project Dashboard",
      "login.email": "Email",
      "login.password": "Password",
      "login.rememberMe": "Remember me",
      "login.forgotPassword": "Forgot password?",
      "login.signIn": "Sign In",
      "login.continueWith": "Or continue with",
      "login.demoLogin": "Demo Login (Quick Access)",
      "login.noAccount": "Don't have an account?",
      "login.signUp": "Sign Up",
      "login.termsText": "By signing in, you agree to our",
      "login.termsService": "Terms of Service",
      "login.and": "and",
      "login.privacyPolicy": "Privacy Policy",
      "login.feature1Title": "Real-time Project Analysis",
      "login.feature1Desc": "Transform your data into actionable insights with AI-powered analytics",
      "login.feature2Title": "AI Assistant (GPT-4o)",
      "login.feature2Desc": "Chat with your Project Controller for instant recommendations and forecasts",
      "login.feature3Title": "Risk Detection & Monitoring",
      "login.feature3Desc": "Automated anomaly detection with smart alerts and drill-down analysis",
      
      // Register Page
      "register.title": "Create Account",
      "register.subtitle": "Start managing your projects today",
      "register.fullName": "Full Name",
      "register.company": "Company (Optional)",
      "register.role": "Role (Optional)",
      "register.confirmPassword": "Confirm Password",
      "register.createAccount": "Create Account",
      "register.hasAccount": "Already have an account?",
      
      // Dashboard Home
      "home.title": "Project Cost Control",
      "home.headerTag": "Project Dashboard",
      "home.projectSelector": "Select Project",
      "home.contractValue": "Contract Value",
      "home.duration": "Duration",
      "home.physicalProgress": "Physical Progress",
      "home.budgetSpent": "Budget Spent",
      "home.remaining": "Remaining",
      "home.schedulePerformance": "Schedule Performance",
      "home.slightDelay": "Slight Delay",
      "home.onSchedule": "On Schedule",
      "home.behindSchedule": "Behind Schedule",
      "home.forecastCompletion": "Forecast at Completion",
      "home.vsBudget": "vs Budget",
      "home.dashboardModules": "Dashboard Modules",
      "home.aiAssistant": "AI Assistant",
      "home.aiAssistantDesc": "Risk analysis & recommendations",
      "home.physicalProgressModule": "Physical Progress",
      "home.physicalProgressDesc": "Discipline-wise progress tracking",
      "home.costAnalysis": "Cost Analysis",
      "home.costAnalysisDesc": "Budget vs actual breakdown",
      "home.cashFlow": "Cash Flow",
      "home.cashFlowDesc": "Income vs expense tracking",
      "home.manpowerModule": "Manpower",
      "home.manpowerDesc": "Resource allocation & planning",
      "home.deviations": "Deviations & Actions",
      "home.deviationsDesc": "Risk monitoring & mitigation",
      "home.sCurve": "S-Curve Analysis",
      "home.sCurveDesc": "Cumulative progress over time",
      "home.evmDashboard": "EVM Dashboard",
      "home.evmDashboardDesc": "Earned Value Management",
      "home.activeDeviations": "Active Deviations",
      "home.keyMilestones": "Key Milestones",
      
      // Progress Page
      "progress.title": "Physical Progress",
      "progress.subtitle": "Discipline-wise tracking",
      "progress.overallProgress": "Overall Progress",
      "progress.variance": "variance",
      "progress.byDiscipline": "Progress by Discipline",
      "progress.disciplineDetails": "Discipline Details",
      "progress.planned": "Planned",
      "progress.actual": "Actual",
      "progress.weight": "Weight",
      
      // Cost Analysis Page
      "costs.title": "Cost Analysis",
      "costs.subtitle": "Budget vs Actual",
      "costs.budgetSummary": "Budget Summary",
      "costs.totalBudget": "Total Budget",
      "costs.spentToDate": "Spent to Date",
      "costs.committed": "Committed",
      "costs.budgetUtilization": "Budget Utilization",
      "costs.costDistribution": "Cost Distribution (Budget)",
      "costs.budgetVsActual": "Budget vs Actual",
      "costs.directCosts": "Direct Costs",
      "costs.indirectCosts": "Indirect Costs",
      "costs.under": "under",
      "costs.over": "over",
      
      // Cash Flow Page
      "cashflow.title": "Cash Flow",
      "cashflow.subtitle": "Income vs Expenses",
      "cashflow.summary": "Cash Flow Summary",
      "cashflow.totalInvoiced": "Total Invoiced",
      "cashflow.totalCollected": "Total Collected",
      "cashflow.outstandingAR": "Outstanding AR",
      "cashflow.totalSpent": "Total Spent",
      "cashflow.netCashPosition": "Net Cash Position",
      "cashflow.monthlyIncomeVsCost": "Monthly Income vs Cost",
      "cashflow.netCashFlow": "Net Cash Flow (Income - Cost)",
      "cashflow.monthlyDetails": "Monthly Details",
      "cashflow.collectionPerformance": "Collection Performance",
      "cashflow.collectionRate": "Collection Rate",
      "cashflow.costVsRevenue": "Cost vs Revenue",
      
      // Manpower Page
      "manpower.title": "Manpower",
      "manpower.subtitle": "Resource allocation",
      "manpower.currentWorkforce": "Current Workforce",
      "manpower.totalPersonnel": "Total Personnel",
      "manpower.vsPlanned": "vs Planned",
      "manpower.vsPeak": "vs Peak",
      "manpower.currentDistribution": "Current Distribution",
      "manpower.comparison": "Manpower Comparison",
      "manpower.current": "Current",
      "manpower.peak": "Peak",
      "manpower.direct": "Direct",
      "manpower.indirect": "Indirect",
      "manpower.subcontractor": "Subcon",
      "manpower.resourceUtilization": "Resource Utilization",
      "manpower.currentVsPlanned": "Current vs Planned",
      "manpower.tekfenVsSubcon": "Tekfen vs Subcontractor",
      "manpower.currentVsPeak": "Current vs Peak Capacity",
      
      // Deviations Page
      "deviations.title": "Deviations & Actions",
      "deviations.subtitle": "Risk monitoring",
      "deviations.high": "High",
      "deviations.medium": "Medium",
      "deviations.low": "Low",
      "deviations.activeDeviations": "Active Deviations",
      "deviations.impact": "Impact",
      "deviations.actionPlan": "Action Plan",
      "deviations.inProgress": "In Progress",
      "deviations.onTrack": "On Track",
      "deviations.projectMilestones": "Project Milestones",
      "deviations.completed": "Completed",
      "deviations.upcoming": "Upcoming",
      
      // S-Curve Page
      "scurve.title": "S-Curve Analysis",
      "scurve.subtitle": "Cumulative progress over time",
      "scurve.currentStatus": "Current Progress Status",
      "scurve.chartTitle": "S-Curve Progress Chart",
      "scurve.understanding": "Understanding the S-Curve",
      "scurve.plannedDesc": "Target cumulative progress as per schedule",
      "scurve.actualDesc": "Real cumulative progress achieved",
      "scurve.baselineDesc": "Original project baseline",
      "scurve.gapExplanation": "The gap between planned and actual curves indicates schedule performance. A curve below planned indicates delays; above indicates ahead of schedule.",
      "scurve.monthlyData": "Monthly Progress Data",
      "scurve.baseline": "Baseline",
      
      // EVM Dashboard
      "evm.title": "EVM Dashboard",
      "evm.subtitle": "Earned Value Management",
      "evm.summary": "Earned Value Summary",
      "evm.spi": "SPI",
      "evm.cpi": "CPI",
      "evm.underBudget": "Under Budget",
      "evm.overBudget": "Over Budget",
      "evm.slightOverrun": "Slight Overrun",
      "evm.varianceAnalysis": "Variance Analysis",
      "evm.scheduleVariance": "Schedule Variance (SV)",
      "evm.costVariance": "Cost Variance (CV)",
      "evm.costForecast": "Cost Forecast",
      "evm.bac": "Budget at Completion (BAC)",
      "evm.eac": "Estimate at Completion (EAC)",
      "evm.etc": "Estimate to Complete (ETC)",
      "evm.vac": "Variance at Completion (VAC)",
      "evm.tcpi": "To Complete Performance Index (TCPI)",
      "evm.trendAnalysis": "EVM Trend Analysis",
      "evm.byDiscipline": "EVM by Discipline",
      "evm.terminology": "EVM Terminology",
      
      // Report Export
      "export.title": "Export Report",
      "export.subtitle": "Generate PDF reports",
      "export.selectProject": "Select Project",
      "export.reportType": "Report Type",
      "export.fullReport": "Full Project Report",
      "export.evmReport": "EVM Analysis Report",
      "export.progressReport": "Progress Report",
      "export.deviationsReport": "Deviations & Risk Report",
      "export.reportContents": "Report Contents",
      "export.projectInfo": "Project Information & KPIs",
      "export.generatePdf": "Generate PDF Report",
      "export.generating": "Generating...",
      "export.downloadNote": "PDF report will be downloaded automatically after generation",
      
      // AI Assistant
      "ai.title": "AI Assistant",
      "ai.subtitle": "GPT-4o • Real-time Analysis",
      "ai.welcome": "Hello! I'm your **Project Cost Control AI Assistant** powered by GPT-4o. I have real-time access to all project data including:",
      "ai.helpWith": "I can help you with:",
      "ai.progressAnalysis": "Progress analysis & forecasting",
      "ai.costVariance": "Cost variance analysis",
      "ai.riskAssessment": "Risk assessment & mitigation",
      "ai.resourceOptimization": "Resource optimization",
      "ai.scheduleRecovery": "Schedule recovery planning",
      "ai.askQuestion": "What would you like to analyze?",
      "ai.scheduleAnalysis": "Schedule Analysis",
      "ai.costPerformance": "Cost Performance",
      "ai.riskAssessmentBtn": "Risk Assessment",
      "ai.whatIfScenarios": "What-If Scenarios",
      "ai.placeholder": "Ask about your projects...",
      "ai.poweredBy": "Powered by OpenAI GPT-4o with real project data",
      "ai.analyzing": "AI is analyzing your data...",
      
      // Settings
      "settings.title": "Settings",
      "settings.subtitle": "App preferences & data management",
      "settings.language": "Language",
      "settings.selectLanguage": "Select Language",
      "settings.english": "English",
      "settings.turkish": "Türkçe",
      "settings.logout": "Logout",
      "settings.navigation": "Quick Navigation",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "Error",
      "common.success": "Success",
      "common.cancel": "Cancel",
      "common.save": "Save",
      "common.month": "Month",
      "common.status": "Status",
      "common.active": "ACTIVE",
      "common.items": "items",
      "common.selectProject": "Select Project",
      "common.planned": "Planned",
      "common.actual": "Actual",
      "common.budget": "Budget",
      "common.variance": "Variance",
      "common.projected": "Projected",
      "common.completed": "Completed",
      "deviations.delayed": "Delayed",
      "scurve.month": "Month",
      "evm.pvLabel": "PV (BCWS)",
      "evm.evLabel": "EV (BCWP)",
      "evm.acLabel": "AC (ACWP)",
      "evm.onSchedule": "On Schedule",
      "evm.slightDelay": "Slight Delay",
      "evm.behindSchedule": "Behind Schedule",
      "evm.svFormula": "EV - PV",
      "evm.cvFormula": "EV - AC",
      "evm.legendPV": "PV (Planned)",
      "evm.legendEV": "EV (Earned)",
      "evm.legendAC": "AC (Actual)",
      "evm.termPV": "Budgeted Cost of Work Scheduled - Planned Value",
      "evm.termEV": "Budgeted Cost of Work Performed - Earned Value",
      "evm.termAC": "Actual Cost of Work Performed",
      "evm.termSPI": "Schedule Performance Index (EV/PV) - >1 is good",
      "evm.termCPI": "Cost Performance Index (EV/AC) - >1 is good",
      "evm.termEAC": "Estimate at Completion - Projected total cost",
      "evm.termTCPI": "To Complete Performance Index - Required efficiency to meet budget",
      "cashflow.plannedIncome": "Planned Income",
      "cashflow.actualIncome": "Actual Income",
      "cashflow.plannedCost": "Planned Cost",
      "cashflow.actualCost": "Actual Cost",
      "cashflow.plannedNet": "Planned Net",
      "cashflow.actualNet": "Actual Net",
      "cashflow.completed": "Completed",
      "cashflow.projected": "Projected",
      "cashflow.netCashFlowLabel": "Net Cash Flow",
      "export.selectReportType": "Select Report Type",
      "export.toastSelectProject": "Please select a project",
      "export.toastSuccess": "Report generated successfully!",
      "export.toastError": "Failed to generate report",
      "export.evmContent": "Earned Value Management (EVM)",
      "export.progressContent": "Progress by Discipline",
      "export.deviationsContent": "Active Deviations & Risks"
    }
  },
  tr: {
    translation: {
      // Navigation
      "nav.home": "Ana Sayfa",
      "nav.progress": "İlerleme",
      "nav.costs": "Maliyetler",
      "nav.manpower": "İşgücü",
      "nav.more": "Daha Fazla",
      
      // Login Page
      "login.welcome": "Tekrar Hoş Geldiniz",
      "login.subtitle": "Proje Dashboard'unuza erişmek için giriş yapın",
      "login.email": "E-posta",
      "login.password": "Şifre",
      "login.rememberMe": "Beni hatırla",
      "login.forgotPassword": "Şifremi unuttum?",
      "login.signIn": "Giriş Yap",
      "login.continueWith": "Veya şununla devam edin",
      "login.demoLogin": "Demo Girişi (Hızlı Erişim)",
      "login.noAccount": "Hesabınız yok mu?",
      "login.signUp": "Kayıt Ol",
      "login.termsText": "Giriş yaparak kabul etmiş olursunuz:",
      "login.termsService": "Kullanım Şartları",
      "login.and": "ve",
      "login.privacyPolicy": "Gizlilik Politikası",
      "login.feature1Title": "Gerçek Zamanlı Proje Analizi",
      "login.feature1Desc": "Verilerinizi AI destekli analitiklerle eyleme dönüştürülebilir içgörülere dönüştürün",
      "login.feature2Title": "AI Asistan (GPT-4o)",
      "login.feature2Desc": "Anlık öneriler ve tahminler için Proje Kontrolörünüzle sohbet edin",
      "login.feature3Title": "Risk Tespiti ve İzleme",
      "login.feature3Desc": "Akıllı uyarılar ve detaylı analiz ile otomatik anomali tespiti",
      
      // Register Page
      "register.title": "Hesap Oluştur",
      "register.subtitle": "Bugün projelerinizi yönetmeye başlayın",
      "register.fullName": "Ad Soyad",
      "register.company": "Şirket (İsteğe bağlı)",
      "register.role": "Pozisyon (İsteğe bağlı)",
      "register.confirmPassword": "Şifreyi Onayla",
      "register.createAccount": "Hesap Oluştur",
      "register.hasAccount": "Zaten hesabınız var mı?",
      
      // Dashboard Home
      "home.title": "Proje Maliyet Kontrolü",
      "home.headerTag": "Proje Paneli",
      "home.projectSelector": "Proje Seçin",
      "home.contractValue": "Sözleşme Bedeli",
      "home.duration": "Süre",
      "home.physicalProgress": "Fiziksel İlerleme",
      "home.budgetSpent": "Harcanan Bütçe",
      "home.remaining": "Kalan",
      "home.schedulePerformance": "Takvim Performansı",
      "home.slightDelay": "Hafif Gecikme",
      "home.onSchedule": "Takvimde",
      "home.behindSchedule": "Geride",
      "home.forecastCompletion": "Tamamlanma Tahmini",
      "home.vsBudget": "Bütçeye Göre",
      "home.dashboardModules": "Dashboard Modülleri",
      "home.aiAssistant": "AI Asistan",
      "home.aiAssistantDesc": "Risk analizi ve öneriler",
      "home.physicalProgressModule": "Fiziksel İlerleme",
      "home.physicalProgressDesc": "Disiplin bazlı ilerleme takibi",
      "home.costAnalysis": "Maliyet Analizi",
      "home.costAnalysisDesc": "Bütçe ve gerçekleşen karşılaştırma",
      "home.cashFlow": "Nakit Akışı",
      "home.cashFlowDesc": "Gelir ve gider takibi",
      "home.manpowerModule": "İşgücü",
      "home.manpowerDesc": "Kaynak tahsisi ve planlama",
      "home.deviations": "Sapmalar ve Aksiyonlar",
      "home.deviationsDesc": "Risk izleme ve azaltma",
      "home.sCurve": "S-Eğrisi Analizi",
      "home.sCurveDesc": "Zaman bazlı kümülatif ilerleme",
      "home.evmDashboard": "EVM Paneli",
      "home.evmDashboardDesc": "Kazanılmış Değer Yönetimi",
      "home.activeDeviations": "Aktif Sapmalar",
      "home.keyMilestones": "Önemli Kilometre Taşları",
      
      // Progress Page
      "progress.title": "Fiziksel İlerleme",
      "progress.subtitle": "Disiplin bazlı takip",
      "progress.overallProgress": "Genel İlerleme",
      "progress.variance": "sapma",
      "progress.byDiscipline": "Disipline Göre İlerleme",
      "progress.disciplineDetails": "Disiplin Detayları",
      "progress.planned": "Planlanan",
      "progress.actual": "Gerçekleşen",
      "progress.weight": "Ağırlık",
      
      // Cost Analysis Page
      "costs.title": "Maliyet Analizi",
      "costs.subtitle": "Bütçe ve Gerçekleşen",
      "costs.budgetSummary": "Bütçe Özeti",
      "costs.totalBudget": "Toplam Bütçe",
      "costs.spentToDate": "Bugüne Kadar Harcanan",
      "costs.committed": "Taahhüt Edilen",
      "costs.budgetUtilization": "Bütçe Kullanımı",
      "costs.costDistribution": "Maliyet Dağılımı (Bütçe)",
      "costs.budgetVsActual": "Bütçe ve Gerçekleşen",
      "costs.directCosts": "Direkt Maliyetler",
      "costs.indirectCosts": "Endirekt Maliyetler",
      "costs.under": "altında",
      "costs.over": "üstünde",
      
      // Cash Flow Page
      "cashflow.title": "Nakit Akışı",
      "cashflow.subtitle": "Gelir ve Giderler",
      "cashflow.summary": "Nakit Akışı Özeti",
      "cashflow.totalInvoiced": "Toplam Faturalandırılan",
      "cashflow.totalCollected": "Toplam Tahsil Edilen",
      "cashflow.outstandingAR": "Bekleyen Alacaklar",
      "cashflow.totalSpent": "Toplam Harcanan",
      "cashflow.netCashPosition": "Net Nakit Pozisyonu",
      "cashflow.monthlyIncomeVsCost": "Aylık Gelir ve Maliyet",
      "cashflow.netCashFlow": "Net Nakit Akışı (Gelir - Maliyet)",
      "cashflow.monthlyDetails": "Aylık Detaylar",
      "cashflow.collectionPerformance": "Tahsilat Performansı",
      "cashflow.collectionRate": "Tahsilat Oranı",
      "cashflow.costVsRevenue": "Maliyet / Gelir",
      
      // Manpower Page
      "manpower.title": "İşgücü",
      "manpower.subtitle": "Kaynak tahsisi",
      "manpower.currentWorkforce": "Mevcut İşgücü",
      "manpower.totalPersonnel": "Toplam Personel",
      "manpower.vsPlanned": "Planlanana Göre",
      "manpower.vsPeak": "Zirveye Göre",
      "manpower.currentDistribution": "Mevcut Dağılım",
      "manpower.comparison": "İşgücü Karşılaştırması",
      "manpower.current": "Mevcut",
      "manpower.peak": "Zirve",
      "manpower.direct": "Direkt",
      "manpower.indirect": "Endirekt",
      "manpower.subcontractor": "Taşeron",
      "manpower.resourceUtilization": "Kaynak Kullanımı",
      "manpower.currentVsPlanned": "Mevcut / Planlanan",
      "manpower.tekfenVsSubcon": "Tekfen / Taşeron",
      "manpower.currentVsPeak": "Mevcut / Zirve Kapasitesi",
      
      // Deviations Page
      "deviations.title": "Sapmalar ve Aksiyonlar",
      "deviations.subtitle": "Risk izleme",
      "deviations.high": "Yüksek",
      "deviations.medium": "Orta",
      "deviations.low": "Düşük",
      "deviations.activeDeviations": "Aktif Sapmalar",
      "deviations.impact": "Etki",
      "deviations.actionPlan": "Aksiyon Planı",
      "deviations.inProgress": "Devam Ediyor",
      "deviations.onTrack": "Yolunda",
      "deviations.projectMilestones": "Proje Kilometre Taşları",
      "deviations.completed": "Tamamlandı",
      "deviations.upcoming": "Yaklaşan",
      
      // S-Curve Page
      "scurve.title": "S-Eğrisi Analizi",
      "scurve.subtitle": "Zaman bazlı kümülatif ilerleme",
      "scurve.currentStatus": "Mevcut İlerleme Durumu",
      "scurve.chartTitle": "S-Eğrisi İlerleme Grafiği",
      "scurve.understanding": "S-Eğrisini Anlama",
      "scurve.plannedDesc": "Takvime göre hedef kümülatif ilerleme",
      "scurve.actualDesc": "Gerçekleşen kümülatif ilerleme",
      "scurve.baselineDesc": "Orijinal proje baz çizgisi",
      "scurve.gapExplanation": "Planlanan ve gerçekleşen eğriler arasındaki fark takvim performansını gösterir. Planlanın altında bir eğri gecikmeleri, üstünde ise takvimin önünde olunduğunu gösterir.",
      "scurve.monthlyData": "Aylık İlerleme Verileri",
      "scurve.baseline": "Baz Çizgisi",
      
      // EVM Dashboard
      "evm.title": "EVM Paneli",
      "evm.subtitle": "Kazanılmış Değer Yönetimi",
      "evm.summary": "Kazanılmış Değer Özeti",
      "evm.spi": "TPI",
      "evm.cpi": "MPI",
      "evm.underBudget": "Bütçe Altında",
      "evm.overBudget": "Bütçe Üstünde",
      "evm.slightOverrun": "Hafif Aşım",
      "evm.varianceAnalysis": "Sapma Analizi",
      "evm.scheduleVariance": "Takvim Sapması (TS)",
      "evm.costVariance": "Maliyet Sapması (MS)",
      "evm.costForecast": "Maliyet Tahmini",
      "evm.bac": "Tamamlanma Bütçesi (TB)",
      "evm.eac": "Tamamlanma Tahmini (TT)",
      "evm.etc": "Tamamlanması Gereken (TG)",
      "evm.vac": "Tamamlanma Sapması (TS)",
      "evm.tcpi": "Tamamlanma Performans Endeksi (TPE)",
      "evm.trendAnalysis": "EVM Trend Analizi",
      "evm.byDiscipline": "Disipline Göre EVM",
      "evm.terminology": "EVM Terminolojisi",
      
      // Report Export
      "export.title": "Rapor Dışa Aktar",
      "export.subtitle": "PDF rapor oluştur",
      "export.selectProject": "Proje Seçin",
      "export.reportType": "Rapor Türü",
      "export.fullReport": "Tam Proje Raporu",
      "export.evmReport": "EVM Analiz Raporu",
      "export.progressReport": "İlerleme Raporu",
      "export.deviationsReport": "Sapmalar ve Risk Raporu",
      "export.reportContents": "Rapor İçeriği",
      "export.projectInfo": "Proje Bilgileri ve KPI'lar",
      "export.generatePdf": "PDF Rapor Oluştur",
      "export.generating": "Oluşturuluyor...",
      "export.downloadNote": "PDF rapor oluşturulduktan sonra otomatik olarak indirilecektir",
      
      // AI Assistant
      "ai.title": "AI Asistan",
      "ai.subtitle": "GPT-4o • Gerçek Zamanlı Analiz",
      "ai.welcome": "Merhaba! Ben GPT-4o destekli **Proje Maliyet Kontrolü AI Asistanınızım**. Şu projelere gerçek zamanlı erişimim var:",
      "ai.helpWith": "Size şu konularda yardımcı olabilirim:",
      "ai.progressAnalysis": "İlerleme analizi ve tahminleme",
      "ai.costVariance": "Maliyet sapma analizi",
      "ai.riskAssessment": "Risk değerlendirme ve azaltma",
      "ai.resourceOptimization": "Kaynak optimizasyonu",
      "ai.scheduleRecovery": "Takvim kurtarma planlaması",
      "ai.askQuestion": "Ne analiz etmek istersiniz?",
      "ai.scheduleAnalysis": "Takvim Analizi",
      "ai.costPerformance": "Maliyet Performansı",
      "ai.riskAssessmentBtn": "Risk Değerlendirmesi",
      "ai.whatIfScenarios": "Ne Olursa Senaryoları",
      "ai.placeholder": "Projeleriniz hakkında sorun...",
      "ai.poweredBy": "Gerçek proje verileriyle OpenAI GPT-4o tarafından desteklenmektedir",
      "ai.analyzing": "AI verilerinizi analiz ediyor...",
      
      // Settings
      "settings.title": "Ayarlar",
      "settings.subtitle": "Uygulama tercihleri ve veri yönetimi",
      "settings.language": "Dil",
      "settings.selectLanguage": "Dil Seçin",
      "settings.english": "English",
      "settings.turkish": "Türkçe",
      "settings.logout": "Çıkış Yap",
      "settings.navigation": "Hızlı Navigasyon",
      
      // Common
      "common.loading": "Yükleniyor...",
      "common.error": "Hata",
      "common.success": "Başarılı",
      "common.cancel": "İptal",
      "common.save": "Kaydet",
      "common.month": "Ay",
      "common.status": "Durum",
      "common.active": "AKTİF",
      "common.items": "öğe",
      "common.selectProject": "Proje Seçin",
      "common.planned": "Planlanan",
      "common.actual": "Gerçekleşen",
      "common.budget": "Bütçe",
      "common.variance": "Sapma",
      "common.projected": "Tahmini",
      "common.completed": "Tamamlandı",
      "deviations.delayed": "Gecikmeli",
      "scurve.month": "Ay",
      "evm.pvLabel": "PV (BCWS)",
      "evm.evLabel": "EV (BCWP)",
      "evm.acLabel": "AC (ACWP)",
      "evm.onSchedule": "Takvimde",
      "evm.slightDelay": "Hafif Gecikme",
      "evm.behindSchedule": "Geride",
      "evm.svFormula": "EV - PV",
      "evm.cvFormula": "EV - AC",
      "evm.legendPV": "PV (Planlanan)",
      "evm.legendEV": "EV (Kazanılan)",
      "evm.legendAC": "AC (Gerçekleşen)",
      "evm.termPV": "Planlanan İşin Bütçelenmiş Maliyeti - Planlanan Değer",
      "evm.termEV": "Yapılan İşin Bütçelenmiş Maliyeti - Kazanılmış Değer",
      "evm.termAC": "Yapılan İşin Gerçek Maliyeti",
      "evm.termSPI": "Takvim Performans Endeksi (EV/PV) - >1 iyidir",
      "evm.termCPI": "Maliyet Performans Endeksi (EV/AC) - >1 iyidir",
      "evm.termEAC": "Tamamlanma Tahmini - Öngörülen toplam maliyet",
      "evm.termTCPI": "Tamamlanma Performans Endeksi - Bütçeyi tutturmak için gereken verimlilik",
      "cashflow.plannedIncome": "Planlanan Gelir",
      "cashflow.actualIncome": "Gerçekleşen Gelir",
      "cashflow.plannedCost": "Planlanan Maliyet",
      "cashflow.actualCost": "Gerçekleşen Maliyet",
      "cashflow.plannedNet": "Planlanan Net",
      "cashflow.actualNet": "Gerçekleşen Net",
      "cashflow.completed": "Tamamlandı",
      "cashflow.projected": "Öngörülen",
      "cashflow.netCashFlowLabel": "Net Nakit Akışı",
      "export.selectReportType": "Rapor Türü Seçin",
      "export.toastSelectProject": "Lütfen bir proje seçin",
      "export.toastSuccess": "Rapor başarıyla oluşturuldu!",
      "export.toastError": "Rapor oluşturulamadı",
      "export.evmContent": "Kazanılmış Değer Yönetimi (EVM)",
      "export.progressContent": "Disipline Göre İlerleme",
      "export.deviationsContent": "Aktif Sapmalar ve Riskler"
    }
  }
};

// Get saved language from localStorage or default to browser language
const getSavedLanguage = () => {
  const saved = localStorage.getItem('language');
  if (saved) return saved;
  
  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'tr' ? 'tr' : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSavedLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
